import { SlicePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { expandTdDivsAnimation, fadeInAnimation, onlyEnter } from '@zero/shared/ui-animations';
import { SortHelper, SorterLabelComponent } from '@zero/shared/ui-web-components';
import { DataService } from '@zero/shared/util-web-app-services';
import { ExecutedOrderItemComponent } from '../executed-order-item/executed-order-item.component';
import { OrderList } from '../order-list-base';

@Component({
  selector: 'order-zero-executed-orders',
  templateUrl: './executed-orders.component.html',
  animations: [fadeInAnimation, expandTdDivsAnimation, onlyEnter],
  imports: [SorterLabelComponent, ExecutedOrderItemComponent, SlicePipe, TranslocoPipe],
})
export class ExecutedOrdersComponent extends OrderList {
  public hasNext = false;
  public isReady = false;
  public sorter?: SortHelper;

  @Input() public actionsEnabled = true;

  constructor(public override dataService: DataService) {
    super(dataService);
    this.sortAttribute = 'execDate';
    this.sortDirection = 'desc';
    this.sorter = new SortHelper(this.sortAttribute, false, 'executed-orders');
  }

  protected async loadOrders(sorted: boolean): Promise<void> {
    const value = await this.loadExecutedOrders();
    this.hasNext = value.hasNext;
    if (!sorted) {
      this.mergeLoadedOrders(value.list);
    } else {
      this.orders.length = 0;
      this.orders = this.orders.concat(value.list);
    }
    this.isReady = true;
  }

  public async sortBy(sortAttr: string): Promise<void> {
    if (this.sortAttribute && this.sortAttribute === sortAttr) {
      // change direction
      if (this.sortDirection === 'asc') {
        this.sortDirection = 'desc';
      } else {
        this.sortDirection = 'asc';
      }
    }
    await this.loadOrders(true);
    this.sorter.sortBy(this.orders, sortAttr);
  }
}
